<div class="comboIdiomas">
    <mat-form-field floatLabel="never">
        <mat-label>{{'NAVBAR.LANGUAGE' | translate }}</mat-label>
        <div class="mtop20">{{selected | uppercase}}
            <mat-select [(value)]="selected">
                <mat-option *ngFor="let idioma of opcionesIdiomas" class="opcionesIdiomas" [value]="idioma.value"
                    (click)="changeLanguage(idioma.value)">
                    <div class="optionLanguage">{{idioma.value | uppercase}}</div>
                    <!-- <span [ngClass]="idioma.class"></span> -->
                </mat-option>
            </mat-select>
        </div>
    </mat-form-field>
</div>